import React, { useEffect, useState } from 'react'
import AppHeader from '../../components/AppHeader'
import portalServices from '../../portalServices';
import { Link, useNavigate } from 'react-router-dom';


import { Step, StepLabel, Stepper } from '@mui/material';
import QueueWorkingHours from '../../components/QueueWorkingHours';
import CheckinBackButton from '../CheckinBackButton';
const Step1 = () =>{
  return (
    <div className='col-md-12 mt-3 mb-5'>
      <Stepper activeStep={0}>
        <Step>
          <StepLabel>Select Queue</StepLabel>
        </Step>
        <Step>
          <StepLabel>Select Service</StepLabel>
        </Step>
        <Step>
          <StepLabel>Book Token</StepLabel>
        </Step>
      </Stepper>
    </div>
  )
}


function SelectQueuePage() {
  const navigate = useNavigate();
  const [queuList,setQueueList] = useState(null);
  const getQueueList = () =>{
    portalServices.getQueueList().then(res=>{
      setQueueList(res.data);
    }).catch(error=>{

    })
  }
  useEffect(()=>{
    getQueueList();
  },[])

  const selectQueue = (queue) =>{
    if(queue.isOpenNow){
      navigate("/checkin/services",{state:queue})
    }
  }

  return (
    <>
        <AppHeader/>
        <div className='container'>
            <CheckinBackButton/>
            <div className='row'>
                <Step1/>
                <div className='col-md-12'>
                    {queuList && queuList.map(queue=>
                      <div key={queue.id} className="card px-3 py-2 mb-2">
                          <div className='fw-bold' onClick={()=>selectQueue(queue)} style={{cursor:"pointer"}}>{queue.title} </div>
                          {queue.isOpenNow ?
                            
                              <div>
                                <div className='text-success'  >Today's Waiting Time {queue.waitingTime} Minutes</div>
                                <div className="d-flex justify-content-start">
                                  <QueueWorkingHours queue={queue} />
                                  <button className='btn btn-success me-2' onClick={()=>selectQueue(queue)}>Get Token For Today </button>
                                  {queue.queueType !== 3 && <Link to={"/schedule-checkin/queue"} className='btn btn-outline-success'> OR Schedule Your Visit </Link>}
                                </div>
                              
                            </div>
                            :
                            <div className='text-danger' >
                              <QueueWorkingHours queue={queue} />
                              Currently closed {queue.queueType !== 3 && <Link to={"/schedule-checkin/queue"} className='btn btn-success'>Schedule Your Visit </Link> }
                            </div>
                          }
                      </div>
                    )}
                </div>
            </div>
        </div>
    </>
  )
}

export default SelectQueuePage